var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "main-content runner_orders" },
    [
      _c(
        "div",
        [
          _c("pulse-loader", {
            staticClass: "text-center",
            attrs: { loading: _vm.loading, color: _vm.color },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _vm.modalMapData
        ? _c(
            "EmptyCardModal",
            {
              ref: "cashOutModal",
              attrs: {
                modalData: _vm.modalMapData,
                onModalClose: (reset) => (_vm.modalMapData = null),
                onModalAccept: (reset) => (_vm.modalMapData = null),
              },
            },
            [
              _vm._t("default", function () {
                return [
                  _c(
                    "div",
                    [
                      _c("SelectOrdersMap", {
                        attrs: { divisionId: _vm.selectedDivisionId },
                      }),
                    ],
                    1
                  ),
                ]
              }),
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.modalData
        ? _c("customModal", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.modalData,
                expression: "modalData",
              },
            ],
            attrs: {
              onModalClose: _vm.onModalClose,
              onModalAccept: _vm.setBackPack,
              modalData: _vm.modalData,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.blockOrdersModalData
        ? _c("customModal", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.blockOrdersModalData,
                expression: "blockOrdersModalData",
              },
            ],
            attrs: {
              onModalClose: () => {
                _vm.exportToXLS(true)
                _vm.onModalClose()
              },
              onModalAccept: _vm.blockIncomeOrders,
              modalData: _vm.blockOrdersModalData,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      !Object.keys(_vm.sortedOrders).length && !_vm.loading
        ? _c("div", { staticClass: "row" }, [_vm._m(0)])
        : _vm._e(),
      _vm._v(" "),
      !_vm.loading && Object.keys(_vm.sortedOrders).length
        ? _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-md-6" }, [
              _c("div", { staticClass: "card" }, [
                _vm._m(1),
                _vm._v(" "),
                _c("div", { staticClass: "card-body" }, [
                  _c("table", { staticClass: "table table-hover table-sm" }, [
                    _c("thead", [
                      _c("tr", [
                        _c("th"),
                        _vm._v(" "),
                        _c("th", [_vm._v("Имя")]),
                        _vm._v(" "),
                        _vm.$allowTo("use_backpack_system")
                          ? _c("th", [_vm._v("Рюкзак")])
                          : _vm._e(),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c(
                      "tbody",
                      [
                        _vm._l(_vm.runners, function (runner, index) {
                          return Number(index) && !_vm.runnerGroup[index]
                            ? _c("tr", { key: index }, [
                                _c("td", [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.selected_runner,
                                        expression: "selected_runner",
                                      },
                                    ],
                                    attrs: {
                                      name: "runner_radio",
                                      type: "radio",
                                      id: "r_" + index,
                                    },
                                    domProps: {
                                      value: index,
                                      checked: _vm._q(
                                        _vm.selected_runner,
                                        index
                                      ),
                                    },
                                    on: {
                                      change: function ($event) {
                                        _vm.selected_runner = index
                                      },
                                    },
                                  }),
                                ]),
                                _vm._v(" "),
                                _c("td", { staticClass: "runner_link" }, [
                                  _c(
                                    "label",
                                    { attrs: { for: "r_" + index } },
                                    [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(runner) +
                                          "\n                  "
                                      ),
                                      _vm.sortedOrders[index] &&
                                      _vm.sortedOrders[index].length
                                        ? _c("span", [
                                            _vm._v(
                                              "\n                      (" +
                                                _vm._s(
                                                  _vm.sortedOrders[index].length
                                                ) +
                                                ")\n                    "
                                            ),
                                          ])
                                        : _vm._e(),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _vm.sortedOrders[index] &&
                                  _vm.sortedOrders[index].length
                                    ? _c("i", {
                                        staticClass:
                                          "icon-fa icon-fa-hand-o-down",
                                        on: {
                                          click: function ($event) {
                                            return _vm.goTo(index)
                                          },
                                        },
                                      })
                                    : _vm._e(),
                                ]),
                                _vm._v(" "),
                                _vm.$allowTo("use_backpack_system")
                                  ? _c("td", { staticClass: "text-right" }, [
                                      _vm.backPacks[index]
                                        ? _c(
                                            "div",
                                            { staticClass: "backpack" },
                                            [
                                              _c(
                                                "span",
                                                { staticClass: "w_backpack" },
                                                [_vm._v("с рюкзаком")]
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      !_vm.backPacks[index] &&
                                      _vm.sortedOrders[index] &&
                                      _vm.sortedOrders[index].length
                                        ? _c(
                                            "div",
                                            { staticClass: "backpack" },
                                            [
                                              _c(
                                                "button",
                                                {
                                                  staticClass:
                                                    "btn btn-success btn-xs",
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.modalBackPack(
                                                        index
                                                      )
                                                    },
                                                  },
                                                },
                                                [_vm._v("выдать")]
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ])
                                  : _vm._e(),
                              ])
                            : _vm._e()
                        }),
                        _vm._v(" "),
                        Object.keys(_vm.runnerGroup).length
                          ? [
                              _vm._m(2),
                              _vm._v(" "),
                              _vm._l(_vm.runnerGroup, function (runner, index) {
                                return Number(index)
                                  ? _c("tr", { key: index }, [
                                      _c("td", [_vm._v(_vm._s(index))]),
                                      _vm._v(" "),
                                      _c("td", [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.selected_runner,
                                              expression: "selected_runner",
                                            },
                                          ],
                                          attrs: {
                                            name: "runner_radio",
                                            type: "radio",
                                            id: "r_" + index,
                                          },
                                          domProps: {
                                            value: index,
                                            checked: _vm._q(
                                              _vm.selected_runner,
                                              index
                                            ),
                                          },
                                          on: {
                                            change: function ($event) {
                                              _vm.selected_runner = index
                                            },
                                          },
                                        }),
                                      ]),
                                      _vm._v(" "),
                                      _c("td", { staticClass: "runner_link" }, [
                                        _c(
                                          "label",
                                          { attrs: { for: "r_" + index } },
                                          [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(runner) +
                                                "\n                    "
                                            ),
                                            _vm.sortedOrders[index] &&
                                            _vm.sortedOrders[index].length
                                              ? _c("span", [
                                                  _vm._v(
                                                    "\n                      (" +
                                                      _vm._s(
                                                        _vm.sortedOrders[index]
                                                          .length
                                                      ) +
                                                      ")\n                    "
                                                  ),
                                                ])
                                              : _vm._e(),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _vm.sortedOrders[index] &&
                                        _vm.sortedOrders[index].length
                                          ? _c("i", {
                                              staticClass:
                                                "icon-fa icon-fa-hand-o-down",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.goTo(index)
                                                },
                                              },
                                            })
                                          : _vm._e(),
                                      ]),
                                      _vm._v(" "),
                                      _vm.$allowTo("use_backpack_system")
                                        ? _c(
                                            "td",
                                            { staticClass: "text-right" },
                                            [
                                              _vm.backPacks[index]
                                                ? _c(
                                                    "div",
                                                    { staticClass: "backpack" },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "w_backpack",
                                                        },
                                                        [_vm._v("с рюкзаком")]
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              !_vm.backPacks[index] &&
                                              _vm.sortedOrders[index] &&
                                              _vm.sortedOrders[index].length
                                                ? _c(
                                                    "div",
                                                    { staticClass: "backpack" },
                                                    [
                                                      _c(
                                                        "button",
                                                        {
                                                          staticClass:
                                                            "btn btn-success btn-xs",
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.modalBackPack(
                                                                index
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [_vm._v("выдать")]
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ]
                                          )
                                        : _vm._e(),
                                    ])
                                  : _vm._e()
                              }),
                            ]
                          : _vm._e(),
                      ],
                      2
                    ),
                  ]),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-6" }, [
              this.$allowTo("extra_orders_runner_groups")
                ? _c("div", { staticClass: "card" }, [
                    _vm._m(3),
                    _vm._v(" "),
                    _c("div", { staticClass: "card-body" }, [
                      _c("table", { staticClass: "table table-hover" }, [
                        _vm._m(4),
                        _vm._v(" "),
                        _c("tbody", [
                          _c("tr", [
                            _c("td", [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.selected_runner,
                                    expression: "selected_runner",
                                  },
                                ],
                                attrs: {
                                  value: "inWaitList",
                                  name: "runner_radio",
                                  type: "radio",
                                  id: "r_pause",
                                },
                                domProps: {
                                  checked: _vm._q(
                                    _vm.selected_runner,
                                    "inWaitList"
                                  ),
                                },
                                on: {
                                  change: function ($event) {
                                    _vm.selected_runner = "inWaitList"
                                  },
                                },
                              }),
                            ]),
                            _vm._v(" "),
                            _c("td", [
                              _c("label", { attrs: { for: "r_pause" } }, [
                                _vm._v(
                                  "Отстойник (" +
                                    _vm._s(
                                      _vm.sortedOrders.inWaitList
                                        ? _vm.sortedOrders.inWaitList.length
                                        : 0
                                    ) +
                                    ")"
                                ),
                              ]),
                              _vm._v(" "),
                              _vm.sortedOrders.inWaitList &&
                              _vm.sortedOrders.inWaitList.length
                                ? _c("i", {
                                    staticClass: "icon-fa icon-fa-hand-o-down",
                                    on: {
                                      click: function ($event) {
                                        return _vm.goTo("inWaitList")
                                      },
                                    },
                                  })
                                : _vm._e(),
                            ]),
                            _vm._v(" "),
                            _c("td"),
                          ]),
                          _vm._v(" "),
                          _c("tr", [
                            _c("td", [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.selected_runner,
                                    expression: "selected_runner",
                                  },
                                ],
                                attrs: {
                                  value: "futureOrder",
                                  name: "runner_radio",
                                  type: "radio",
                                  id: "r_future",
                                },
                                domProps: {
                                  checked: _vm._q(
                                    _vm.selected_runner,
                                    "futureOrder"
                                  ),
                                },
                                on: {
                                  change: function ($event) {
                                    _vm.selected_runner = "futureOrder"
                                  },
                                },
                              }),
                            ]),
                            _vm._v(" "),
                            _c("td", [
                              _c("label", { attrs: { for: "r_future" } }, [
                                _vm._v(
                                  "Будущие заявки (" +
                                    _vm._s(
                                      _vm.sortedOrders.futureOrder
                                        ? _vm.sortedOrders.futureOrder.length
                                        : 0
                                    ) +
                                    ")"
                                ),
                              ]),
                              _vm._v(" "),
                              _vm.sortedOrders.futureOrder &&
                              _vm.sortedOrders.futureOrder.length
                                ? _c("i", {
                                    staticClass: "icon-fa icon-fa-hand-o-down",
                                    on: {
                                      click: function ($event) {
                                        return _vm.goTo("futureOrder")
                                      },
                                    },
                                  })
                                : _vm._e(),
                            ]),
                            _vm._v(" "),
                            _c("td"),
                          ]),
                        ]),
                      ]),
                    ]),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "card" }, [
                _c("div", { staticClass: "card-body" }, [
                  _c(
                    "div",
                    { staticClass: "flex justify-content-between" },
                    [
                      _vm.blockIncomeOrdersDetail &&
                      _vm.blockIncomeOrdersDetail.active
                        ? _c("div", [
                            _c("div", { staticClass: "alert alert-info" }, [
                              _c("p", { staticClass: "mb-0" }, [
                                _vm._v(
                                  "Прием заявок с доставкой на завтра\n                  "
                                ),
                                _c("strong", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.incomeOrdersBlocked
                                        ? "заблокирован"
                                        : "разрешен"
                                    )
                                  ),
                                ]),
                              ]),
                            ]),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "vue-ladda",
                        {
                          attrs: {
                            "button-class": "btn btn-success mb-3",
                            "data-style": "zoom-in",
                            loading: _vm.exportLoading,
                          },
                          on: { click: () => _vm.exportToXLS() },
                        },
                        [_vm._v("Экспортировать в табличный вид\n            ")]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-group m-0" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.showAllOrders,
                          expression: "showAllOrders",
                        },
                      ],
                      attrs: {
                        type: "radio",
                        id: "r_1",
                        name: "r_1",
                        value: "0",
                      },
                      domProps: { checked: _vm._q(_vm.showAllOrders, "0") },
                      on: {
                        change: function ($event) {
                          _vm.showAllOrders = "0"
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c("label", { attrs: { for: "r_1" } }, [
                      _vm._v(
                        "заявки не позднее завтрашнего дня (" +
                          _vm._s(
                            ((_vm.sortedOrdersFiltered.today &&
                              _vm.sortedOrdersFiltered.today.length) ||
                              0) +
                              ((_vm.sortedOrdersFiltered.tomorrow &&
                                _vm.sortedOrdersFiltered.tomorrow.length) ||
                                0)
                          ) +
                          ")"
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "ml-2" }, [
                      _c("div", { staticClass: "form-group m-0" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.showOrdersFilter.today,
                              expression: "showOrdersFilter.today",
                            },
                          ],
                          attrs: { type: "checkbox", id: "rr_1" },
                          domProps: {
                            checked: Array.isArray(_vm.showOrdersFilter.today)
                              ? _vm._i(_vm.showOrdersFilter.today, null) > -1
                              : _vm.showOrdersFilter.today,
                          },
                          on: {
                            change: function ($event) {
                              var $$a = _vm.showOrdersFilter.today,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = null,
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    _vm.$set(
                                      _vm.showOrdersFilter,
                                      "today",
                                      $$a.concat([$$v])
                                    )
                                } else {
                                  $$i > -1 &&
                                    _vm.$set(
                                      _vm.showOrdersFilter,
                                      "today",
                                      $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1))
                                    )
                                }
                              } else {
                                _vm.$set(_vm.showOrdersFilter, "today", $$c)
                              }
                            },
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "label",
                          { staticClass: "pointer", attrs: { for: "rr_1" } },
                          [
                            _vm._v(
                              "заявки на сегодня и не выполненные ранее\n                  (" +
                                _vm._s(
                                  (_vm.sortedOrdersFiltered.today &&
                                    _vm.sortedOrdersFiltered.today.length) ||
                                    0
                                ) +
                                ")"
                            ),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-group m-0" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.showOrdersFilter.tomorrow,
                              expression: "showOrdersFilter.tomorrow",
                            },
                          ],
                          attrs: { type: "checkbox", id: "rr_2" },
                          domProps: {
                            checked: Array.isArray(
                              _vm.showOrdersFilter.tomorrow
                            )
                              ? _vm._i(_vm.showOrdersFilter.tomorrow, null) > -1
                              : _vm.showOrdersFilter.tomorrow,
                          },
                          on: {
                            change: function ($event) {
                              var $$a = _vm.showOrdersFilter.tomorrow,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = null,
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    _vm.$set(
                                      _vm.showOrdersFilter,
                                      "tomorrow",
                                      $$a.concat([$$v])
                                    )
                                } else {
                                  $$i > -1 &&
                                    _vm.$set(
                                      _vm.showOrdersFilter,
                                      "tomorrow",
                                      $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1))
                                    )
                                }
                              } else {
                                _vm.$set(_vm.showOrdersFilter, "tomorrow", $$c)
                              }
                            },
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "label",
                          { staticClass: "pointer", attrs: { for: "rr_2" } },
                          [
                            _vm._v(
                              'заявки на завтра и "раньше при наличии"\n                  (' +
                                _vm._s(
                                  ((_vm.sortedOrdersFiltered.tomorrow &&
                                    _vm.sortedOrdersFiltered.tomorrow.length) ||
                                    0) +
                                    ((_vm.sortedOrdersFiltered.early &&
                                      _vm.sortedOrdersFiltered.early.length) ||
                                      0)
                                ) +
                                ")"
                            ),
                          ]
                        ),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-group m-0" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.showAllOrders,
                          expression: "showAllOrders",
                        },
                      ],
                      attrs: {
                        type: "radio",
                        id: "r_3",
                        name: "r_1",
                        value: "2",
                      },
                      domProps: { checked: _vm._q(_vm.showAllOrders, "2") },
                      on: {
                        change: function ($event) {
                          _vm.showAllOrders = "2"
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c("label", { attrs: { for: "r_3" } }, [
                      _vm._v(
                        "заявки на поздний срок (" +
                          _vm._s(
                            (_vm.sortedOrdersFiltered.future &&
                              _vm.sortedOrdersFiltered.future.length) ||
                              0
                          ) +
                          ")"
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-group m-0" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.showAllOrders,
                          expression: "showAllOrders",
                        },
                      ],
                      attrs: {
                        type: "radio",
                        id: "r_2",
                        name: "r_1",
                        value: "1",
                      },
                      domProps: { checked: _vm._q(_vm.showAllOrders, "1") },
                      on: {
                        change: function ($event) {
                          _vm.showAllOrders = "1"
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c("label", { attrs: { for: "r_2" } }, [
                      _vm._v(
                        "все заявки (" +
                          _vm._s(
                            _vm.sortedOrders[0] ? _vm.sortedOrders[0].length : 0
                          ) +
                          ")"
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _vm._m(5),
                  _vm._v(" "),
                  _c("div", [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-info btn-sm",
                        attrs: { type: "button" },
                        on: { click: _vm.getOrders },
                      },
                      [_vm._v("\n              Обновить заявки\n            ")]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-default btn-sm",
                        attrs: { type: "button" },
                        on: { click: _vm.toggleAllRunners },
                      },
                      [
                        _vm._v(
                          "\n              " +
                            _vm._s(
                              _vm.showAllRunnerOrders ? "Скрыть" : "Показать"
                            ) +
                            " заявки всех\n              курьеров\n            "
                        ),
                      ]
                    ),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              !_vm.mobileDevice
                ? _c("div", { staticClass: "card print_block" }, [
                    _c("div", { staticClass: "card-header" }, [
                      _c("h6", [
                        _vm._v("Печать\n            "),
                        _c(
                          "button",
                          {
                            staticClass: "pull-right btn btn-default",
                            on: { click: _vm.showPrintBlock },
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(
                                  _vm.showPrintTable ? "Скрыть" : "Показать"
                                ) +
                                "\n            "
                            ),
                          ]
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _vm.showPrintTable
                      ? _c("div", { staticClass: "card-body" }, [
                          _c("div", { staticClass: "row text-left" }, [
                            _c(
                              "div",
                              { staticClass: "col-md-6" },
                              _vm._l(_vm.runners, function (name, runnerId) {
                                return Number.isInteger(parseInt(runnerId)) &&
                                  _vm.sortedOrders[runnerId] &&
                                  _vm.sortedOrders[runnerId].length
                                  ? _c(
                                      "div",
                                      { staticClass: "form-group m-0" },
                                      [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value:
                                                _vm.selectedRunnersForPrint[
                                                  runnerId
                                                ],
                                              expression:
                                                "selectedRunnersForPrint[runnerId]",
                                            },
                                          ],
                                          attrs: {
                                            type: "checkbox",
                                            id: `select_print_${runnerId}`,
                                          },
                                          domProps: {
                                            checked: Array.isArray(
                                              _vm.selectedRunnersForPrint[
                                                runnerId
                                              ]
                                            )
                                              ? _vm._i(
                                                  _vm.selectedRunnersForPrint[
                                                    runnerId
                                                  ],
                                                  null
                                                ) > -1
                                              : _vm.selectedRunnersForPrint[
                                                  runnerId
                                                ],
                                          },
                                          on: {
                                            change: function ($event) {
                                              var $$a =
                                                  _vm.selectedRunnersForPrint[
                                                    runnerId
                                                  ],
                                                $$el = $event.target,
                                                $$c = $$el.checked
                                                  ? true
                                                  : false
                                              if (Array.isArray($$a)) {
                                                var $$v = null,
                                                  $$i = _vm._i($$a, $$v)
                                                if ($$el.checked) {
                                                  $$i < 0 &&
                                                    _vm.$set(
                                                      _vm.selectedRunnersForPrint,
                                                      runnerId,
                                                      $$a.concat([$$v])
                                                    )
                                                } else {
                                                  $$i > -1 &&
                                                    _vm.$set(
                                                      _vm.selectedRunnersForPrint,
                                                      runnerId,
                                                      $$a
                                                        .slice(0, $$i)
                                                        .concat(
                                                          $$a.slice($$i + 1)
                                                        )
                                                    )
                                                }
                                              } else {
                                                _vm.$set(
                                                  _vm.selectedRunnersForPrint,
                                                  runnerId,
                                                  $$c
                                                )
                                              }
                                            },
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "label",
                                          {
                                            attrs: {
                                              for: `select_print_${runnerId}`,
                                            },
                                          },
                                          [_vm._v(_vm._s(name))]
                                        ),
                                      ]
                                    )
                                  : _vm._e()
                              }),
                              0
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-md-6" }, [
                              _c("h5", [_vm._v("Также включить в печать")]),
                              _vm._v(" "),
                              _c("div", { staticClass: "form-group m-0" }, [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.selectedRunnersForPrint[0],
                                      expression: "selectedRunnersForPrint[0]",
                                    },
                                  ],
                                  attrs: {
                                    type: "checkbox",
                                    id: "select_print_0",
                                  },
                                  domProps: {
                                    checked: Array.isArray(
                                      _vm.selectedRunnersForPrint[0]
                                    )
                                      ? _vm._i(
                                          _vm.selectedRunnersForPrint[0],
                                          null
                                        ) > -1
                                      : _vm.selectedRunnersForPrint[0],
                                  },
                                  on: {
                                    change: function ($event) {
                                      var $$a = _vm.selectedRunnersForPrint[0],
                                        $$el = $event.target,
                                        $$c = $$el.checked ? true : false
                                      if (Array.isArray($$a)) {
                                        var $$v = null,
                                          $$i = _vm._i($$a, $$v)
                                        if ($$el.checked) {
                                          $$i < 0 &&
                                            _vm.$set(
                                              _vm.selectedRunnersForPrint,
                                              0,
                                              $$a.concat([$$v])
                                            )
                                        } else {
                                          $$i > -1 &&
                                            _vm.$set(
                                              _vm.selectedRunnersForPrint,
                                              0,
                                              $$a
                                                .slice(0, $$i)
                                                .concat($$a.slice($$i + 1))
                                            )
                                        }
                                      } else {
                                        _vm.$set(
                                          _vm.selectedRunnersForPrint,
                                          0,
                                          $$c
                                        )
                                      }
                                    },
                                  },
                                }),
                                _vm._v(" "),
                                _c(
                                  "label",
                                  { attrs: { for: "select_print_0" } },
                                  [_vm._v("Не распределенные")]
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "form-group m-0" }, [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value:
                                        _vm.selectedRunnersForPrint.inWaitList,
                                      expression:
                                        "selectedRunnersForPrint.inWaitList",
                                    },
                                  ],
                                  attrs: {
                                    type: "checkbox",
                                    id: "select_print_w",
                                  },
                                  domProps: {
                                    checked: Array.isArray(
                                      _vm.selectedRunnersForPrint.inWaitList
                                    )
                                      ? _vm._i(
                                          _vm.selectedRunnersForPrint
                                            .inWaitList,
                                          null
                                        ) > -1
                                      : _vm.selectedRunnersForPrint.inWaitList,
                                  },
                                  on: {
                                    change: function ($event) {
                                      var $$a =
                                          _vm.selectedRunnersForPrint
                                            .inWaitList,
                                        $$el = $event.target,
                                        $$c = $$el.checked ? true : false
                                      if (Array.isArray($$a)) {
                                        var $$v = null,
                                          $$i = _vm._i($$a, $$v)
                                        if ($$el.checked) {
                                          $$i < 0 &&
                                            _vm.$set(
                                              _vm.selectedRunnersForPrint,
                                              "inWaitList",
                                              $$a.concat([$$v])
                                            )
                                        } else {
                                          $$i > -1 &&
                                            _vm.$set(
                                              _vm.selectedRunnersForPrint,
                                              "inWaitList",
                                              $$a
                                                .slice(0, $$i)
                                                .concat($$a.slice($$i + 1))
                                            )
                                        }
                                      } else {
                                        _vm.$set(
                                          _vm.selectedRunnersForPrint,
                                          "inWaitList",
                                          $$c
                                        )
                                      }
                                    },
                                  },
                                }),
                                _vm._v(" "),
                                _c(
                                  "label",
                                  { attrs: { for: "select_print_w" } },
                                  [_vm._v("Отстойник")]
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "form-group m-0" }, [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value:
                                        _vm.selectedRunnersForPrint.futureOrder,
                                      expression:
                                        "selectedRunnersForPrint.futureOrder",
                                    },
                                  ],
                                  attrs: {
                                    type: "checkbox",
                                    id: "select_print_f",
                                  },
                                  domProps: {
                                    checked: Array.isArray(
                                      _vm.selectedRunnersForPrint.futureOrder
                                    )
                                      ? _vm._i(
                                          _vm.selectedRunnersForPrint
                                            .futureOrder,
                                          null
                                        ) > -1
                                      : _vm.selectedRunnersForPrint.futureOrder,
                                  },
                                  on: {
                                    change: function ($event) {
                                      var $$a =
                                          _vm.selectedRunnersForPrint
                                            .futureOrder,
                                        $$el = $event.target,
                                        $$c = $$el.checked ? true : false
                                      if (Array.isArray($$a)) {
                                        var $$v = null,
                                          $$i = _vm._i($$a, $$v)
                                        if ($$el.checked) {
                                          $$i < 0 &&
                                            _vm.$set(
                                              _vm.selectedRunnersForPrint,
                                              "futureOrder",
                                              $$a.concat([$$v])
                                            )
                                        } else {
                                          $$i > -1 &&
                                            _vm.$set(
                                              _vm.selectedRunnersForPrint,
                                              "futureOrder",
                                              $$a
                                                .slice(0, $$i)
                                                .concat($$a.slice($$i + 1))
                                            )
                                        }
                                      } else {
                                        _vm.$set(
                                          _vm.selectedRunnersForPrint,
                                          "futureOrder",
                                          $$c
                                        )
                                      }
                                    },
                                  },
                                }),
                                _vm._v(" "),
                                _c(
                                  "label",
                                  { attrs: { for: "select_print_f" } },
                                  [_vm._v("Будущие заявки")]
                                ),
                              ]),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "text-right" }, [
                            _vm.printing
                              ? _c(
                                  "span",
                                  { staticClass: "m-r-5 badge badge-info" },
                                  [_vm._v("Формируется страница для печати")]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-success",
                                attrs: { type: "button" },
                                on: {
                                  click: function ($event) {
                                    return _vm.printOrders(false, true)
                                  },
                                },
                              },
                              [_vm._v("Печать")]
                            ),
                          ]),
                        ])
                      : _vm._e(),
                  ])
                : _vm._e(),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { attrs: { id: "print_orders" } },
        [
          !_vm.loading && _vm.sortedOrders[0] && _vm.sortedOrders[0].length
            ? _c(
                "div",
                { class: { row: true, no_print: !_vm.showRunnerOrders[0] } },
                [
                  _c("div", { staticClass: "col-md-12" }, [
                    _c("div", { staticClass: "card" }, [
                      _c("div", { staticClass: "card-header" }, [
                        _c("div", [
                          _c("h5", { staticClass: "pull-left" }, [
                            _vm._v(
                              "Не распределенные (" +
                                _vm._s(_vm.getTotalOrdersAmount()) +
                                ")"
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "no_print pull-right flex" },
                            [
                              [1, 79, 88].includes(+_vm.selectedDivisionId)
                                ? [
                                    _c(
                                      "button",
                                      {
                                        staticClass:
                                          "btn btn-outline-info mr-2",
                                        on: {
                                          click: function ($event) {
                                            _vm.modalMapData = { size: "xl" }
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "Показать заявки на\n                    карте\n                  "
                                        ),
                                      ]
                                    ),
                                  ]
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "button",
                                {
                                  staticClass: "btn btn-default",
                                  on: {
                                    click: function ($event) {
                                      _vm.showRunnerOrders[0] =
                                        !_vm.showRunnerOrders[0]
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(
                                        _vm.showRunnerOrders[0]
                                          ? "Скрыть"
                                          : "Показать"
                                      ) +
                                      "\n                "
                                  ),
                                ]
                              ),
                            ],
                            2
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _vm.showRunnerOrders[0]
                        ? _c(
                            "div",
                            { staticClass: "card-body" },
                            [
                              _vm.mobileDevice
                                ? [
                                    _c("MobileOrderList", {
                                      attrs: {
                                        divisionId: _vm.selectedDivisionId,
                                        updateOrders: _vm.getOrders,
                                        orders: _vm.getTotalOrdersAmount(true),
                                        storeStatusByOrders:
                                          _vm.storeStatusByOrders,
                                        selectedRunner: _vm.selected_runner,
                                        runnerName:
                                          _vm.runners[_vm.selected_runner],
                                      },
                                    }),
                                  ]
                                : [
                                    _c("OrderList", {
                                      attrs: {
                                        divisionId: _vm.selectedDivisionId,
                                        tableMobileAdaptation:
                                          _vm.tableMobileAdaptation,
                                        toPrint: _vm.ordersToPrint,
                                        storeStatusByOrders:
                                          _vm.storeStatusByOrders,
                                        orders: _vm.getTotalOrdersAmount(true),
                                        selectedRunner: _vm.selected_runner,
                                        runnerName:
                                          _vm.runners[_vm.selected_runner],
                                        updateRootOrders: _vm.updateRootOrders,
                                        metroLines: _vm.metroLines,
                                      },
                                    }),
                                  ],
                            ],
                            2
                          )
                        : _vm._e(),
                    ]),
                  ]),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm._l(_vm.sortedOrders, function (orders, index) {
            return _c(
              "div",
              {
                key: index,
                class: { row: true, no_print: !_vm.showRunnerOrders[index] },
              },
              [
                _vm.runners[index] && orders && orders.length
                  ? _c("div", { staticClass: "col-md-12" }, [
                      _c(
                        "div",
                        {
                          ref: `runner_table_${index}`,
                          refInFor: true,
                          staticClass: "card",
                          attrs: { id: `runner_table_${index}` },
                        },
                        [
                          _c("div", { staticClass: "card-header" }, [
                            _c("h5", [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.runners[index]) +
                                  " (" +
                                  _vm._s(orders.length) +
                                  ")\n              "
                              ),
                              _c(
                                "button",
                                {
                                  staticClass:
                                    "btn btn-default pull-right no_print",
                                  on: {
                                    click: function ($event) {
                                      _vm.showRunnerOrders[index] =
                                        !_vm.showRunnerOrders[index]
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        _vm.showRunnerOrders[index]
                                          ? "Скрыть"
                                          : "Показать"
                                      ) +
                                      "\n              "
                                  ),
                                ]
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _vm.showRunnerOrders[index]
                            ? _c(
                                "div",
                                { staticClass: "card-body" },
                                [
                                  _vm.mobileDevice
                                    ? [
                                        _c("MobileOrderList", {
                                          attrs: {
                                            divisionId: _vm.selectedDivisionId,
                                            updateOrders: _vm.getOrders,
                                            orders: orders,
                                            runnerId: index,
                                            storeStatusByOrders:
                                              _vm.storeStatusByOrders,
                                          },
                                        }),
                                      ]
                                    : [
                                        _c("OrderList", {
                                          attrs: {
                                            divisionId: _vm.selectedDivisionId,
                                            tableMobileAdaptation:
                                              _vm.tableMobileAdaptation,
                                            toPrint: _vm.ordersToPrint,
                                            storeStatusByOrders:
                                              _vm.storeStatusByOrders,
                                            orders: orders,
                                            updateRootOrders:
                                              _vm.updateRootOrders,
                                            runnerId: index,
                                            metroLines: _vm.metroLines,
                                            useOrderNum:
                                              Number.isInteger(+index) &&
                                              index > 0,
                                          },
                                        }),
                                      ],
                                ],
                                2
                              )
                            : _vm._e(),
                        ]
                      ),
                    ])
                  : _vm._e(),
              ]
            )
          }),
        ],
        2
      ),
      _vm._v(" "),
      _c("back-to-top", { attrs: { bottom: "50px", right: "50px" } }, [
        _c(
          "button",
          { staticClass: "btn btn-info btn-to-top", attrs: { type: "button" } },
          [_c("i", { staticClass: "icon-fa icon-fa-chevron-up" })]
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-md-12" }, [
      _c("h5", [_vm._v("Заявок не найдено")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-header" }, [
      _c("h6", [_vm._v("Курьеры из Вашей группы")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("tr", [
      _c("td", { staticClass: "group_separate", attrs: { colspan: "10" } }, [
        _vm._v("Курьеры - срочники"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-header" }, [
      _c("h6", [_vm._v("Дополнительные группы")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [_c("th"), _vm._v(" "), _c("th"), _vm._v(" "), _c("th")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "legend" }, [
      _c("p", [
        _c("span", { staticClass: "span span_1" }),
        _vm._v("не хватает"),
      ]),
      _vm._v(" "),
      _c("p", [
        _c("span", { staticClass: "span span_2" }),
        _vm._v("не хватает на всех"),
      ]),
      _vm._v(" "),
      _c("p", [_c("span", { staticClass: "span span_3" }), _vm._v("в дороге")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }